import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizza nome/cognome: prima lettera maiuscola di ogni parola, resto
 * minuscolo, gestendo apostrofi (D'Angelo) e trattini (Anna-Maria).
 * Gemella di formatta_nome() del backend, che resta la fonte di verità:
 * qui serve solo a dare all'utente un'anteprima già pulita nel form.
 */
export function formattaNome(s) {
  if (!s) return "";
  const parola = (p) => {
    if (!p) return p;
    const low = p.toLowerCase();
    if (low.includes("'")) return low.split("'").map(parola).join("'");
    if (low.includes("-")) return low.split("-").map(parola).join("-");
    return low.charAt(0).toUpperCase() + low.slice(1);
  };
  return s.trim().split(/\s+/).map(parola).join(" ");
}

/**
 * Numero in formato internazionale senza segni, per i link wa.me.
 * Assume l'Italia (+39) se manca il prefisso. Gemella di normalizza_telefono().
 */
export function waNumero(tel) {
  if (!tel) return "";
  const raw = String(tel).trim();
  const haPiu = raw.startsWith("+") || raw.startsWith("00");
  let cifre = raw.replace(/\D/g, "");
  if (raw.startsWith("00")) cifre = cifre.slice(2);
  if (!cifre) return "";
  if (!haPiu && !cifre.startsWith("39")) cifre = "39" + cifre;
  return cifre;
}

// Fascia d'età ammessa per gli Animati, calcolata al 1° luglio dell'anno corrente
export const ETA_MIN_ANIMATO = 6;
export const ETA_MAX_ANIMATO = 11;

/** Anni compiuti al 1° luglio dell'anno corrente; null se data non valida. */
export function etaAl1Luglio(dataNascita) {
  if (!dataNascita) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dataNascita).trim());
  if (!m) return null;
  const [, y, mo, d] = m.map(Number);
  const anno = new Date().getFullYear();
  let eta = anno - y;
  // sottrae 1 se al 1° luglio non ha ancora compiuto gli anni
  if (7 < mo || (7 === mo && 1 < d)) eta -= 1;
  return eta;
}

/** True se al 1° luglio l'età compiuta è tra 6 e 11 inclusi. */
export function etaAnimatoValida(dataNascita) {
  const e = etaAl1Luglio(dataNascita);
  return e !== null && e >= ETA_MIN_ANIMATO && e <= ETA_MAX_ANIMATO;
}
